import { Grid, Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useStyles } from './HomePage.styles';

/* export function HomePageBlock({ title, children }: Props) {
  return (
    <div style={{ padding: '5px', textAlign: 'center' }}>
      <div className={'dx-card responsive-paddings'}>
        <div style={{ fontSize: '18px', marginBottom: '5px' }}>{title}</div>
        {children}
      </div>
    </div>
  );
}

export function HomePageBlockCount({ count }: { count: number }) {
  return <div style={{ fontWeight: 'bold', fontSize: '30px' }}>{count}</div>;
} */
interface Props {
  title: string;
  value?: number;
}

export function HomePageBlock({ title, value }: Props) {
  const classes = useStyles();
  return (
    <>
      <Grid item xs={12} md={2.4}>
        <Box
          sx={{
            display: 'flex',
            '& > :not(style)': {
              width: 350,
              height: 200,
              border: '0.1px solid grey',
            },
          }}
        >
          <Paper className={classes.paper} square>
            <Typography variant={'h5'} align="center" mt={15 + '%'}>
              {title}
            </Typography>
            <Typography style={{ fontWeight: 'bold', fontSize: '40px', textAlign: 'center' }}>
              {value}
            </Typography>
          </Paper>
        </Box>
      </Grid>
    </>
  );
}
